import { render, staticRenderFns } from "./input.vue?vue&type=template&id=531b0d9a&scoped=true&"
import script from "./input.vue?vue&type=script&lang=js&"
export * from "./input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b0d9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531b0d9a')) {
      api.createRecord('531b0d9a', component.options)
    } else {
      api.reload('531b0d9a', component.options)
    }
    module.hot.accept("./input.vue?vue&type=template&id=531b0d9a&scoped=true&", function () {
      api.rerender('531b0d9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/input.vue"
export default component.exports